module.exports = __webpack_public_path__ + "img/Ledger-Nano-X-Label-Icon.e56dc6a3.svg";